import type { Sistema } from "@/api/contrato";

export const WEBHOOK_SEM_SEGREDO = "Webhook sem segredo";

/**
 * Tem para onde entregar, e não tem como assinar. A API escreve a URL ausente como `""`, e não
 * omite o campo: texto vazio vale como ausente. Sem URL não há aviso, porque não querer webhook
 * é escolha válida.
 */
export function urlSemSegredo(sistema: Sistema): boolean {
  return Boolean(sistema.entrega?.url) && sistema.entrega?.segredo_configurado !== true;
}
